var _a;
/**
 * @hidden
 */
export var splitBarLabel = 'splitBarLabel';
/**
 * @hidden
 */
export var messages = (_a = {},
    _a[splitBarLabel] = 'split bar',
    _a);
